import React, { useEffect, useState, useCallback } from "react"
import PropTypes from "prop-types"
import axios from "axios";
import * as ActionCable from '@rails/actioncable'

const FundsVerification = ({ identifier, widget_url }) => {
  const legalUrl = (path) => {
    if (typeof window !== "undefined" && window.location?.origin) {
      return `${window.location.origin}${path}`
    }
    return path
  }

  if (!identifier){
    return null
  }

  const [step, setStep] = useState(0);
  const [bankingUrl, setbankingUrl] = useState(null);
  const [accounts, setAccounts] = useState([]);
  const [errorMsg, setErrorMsg] = useState(null);
  const [externalIdentifier, setExternalIdentifier] = useState(null);

  // if there are existing accounts or after a new submission
  const [showSubmitBtn, setShowSubmitBtn] = useState(false); 

  window.App || (window.App = {});
  window.App.cable = ActionCable.createConsumer();

  useEffect(() => {
    getIframe();

    App.cable.subscriptions.create({ channel: "BankingChannel", id: identifier, user_type: 'financial_user' }, {
      connected() {
        console.log("Connected to the channel:", this);
      },
      disconnected() {
        console.log("Disconnected");
      },
      received(data) {
        if (data.account_list){
          setAccounts([...data.account_list, ...accounts])
          setShowSubmitBtn(true)
        }
      }
    });

  }, [identifier])

  useEffect(() => {
    if (step == 1) {
      var postData = {
        status: "CUSTOM_THEME",
        theme: "<style>.header,.bg-progress,.progress{display: none;} .statement-wrapper>p, .tips-section li:first-child{display: none} button.btn_ua.lg{background-color: #0b0047 !important; color: #fff}</style>"
      }
      let receiverWindow = document.getElementById('bankingWidget')//.contentWindow;
      receiverWindow.onload = () => {
        receiverWindow.contentWindow.postMessage(postData, widget_url)
      }
    }
  }, [step])

  const addFundingSource = () => {
    setStep(1)
  }

  const getIframe = useCallback(async () => {
    axios.get('/bank_verification/user_accounts?identifier=' + identifier)
      .then(( { data } ) => {
        setbankingUrl(data.credential_url);
        setAccounts(data.accounts);
        setExternalIdentifier(data.external_identifier);
      })
      .catch(( { response } ) => {
        if (response.data?.error){
          setErrorMsg(response.data.error)
        }
      })
  })

  if (!bankingUrl) {
    return (
      <>
        {errorMsg ? <div className="notification is-danger mt-5">{errorMsg}</div> : <button className="button is-primary color-1 is-loading">Loading</button>}
      </>
    )
  }

  const submitAccounts = () =>{
    setStep(3)
    setShowSubmitBtn(false)
  }

  return(
    <div>
      {step == 0 && <h1 className="has-text-weight-semibold is-size-3">Verify bank data via FundsValidator</h1>}
      <div>
        <h2 className="has-text-weight-semibold is-size-4 mr-3">
          User Identifier: {externalIdentifier}
        </h2>
        <div className="is-flex is-justify-content-space-evenly my-3">
          {showSubmitBtn && 
            <button onClick={()=> submitAccounts()} className="button is-success">
              <span className="icon is-small">
                <i className="fas fa-check"></i>
              </span>
              <span>Complete Upload</span>
            </button>
          }
          {accounts.length > 0 && 
            <a href={"/summary/" + identifier} target="_blank" className="button is-primary is-outlined">
              <span className="icon is-small">
                <i className="fas fa-list"></i>
              </span>
              <span>View Summary</span>
            </a>
          }
        </div>
      </div>

      {step == 3 &&
        <div className="notification is-primary">
          Your bank data has been submitted! You will be contacted shortly with next steps
        </div>
      }

      {step == 1 && 
        <div>
          <iframe src={bankingUrl} width="100%" height="500" style={{ border: '1px solid black'}} id="bankingWidget"></iframe>
        </div>
      } 

      {step == 0 && 
        <>
          <div className="content has-text-left">
            You may choose to share data in two ways:
            <ol>
              <li>Use your bank log-in credentials.</li>
              <li>Upload your bank statement(s)
                <ul>
                  <li>Must have been retrieved in PDF format within the past 14 days, directly from your bank's online portal</li>
                  <li>Upload the past six months of bank-generated statements, with one statement per file</li>
                </ul>
              </li>
            </ol>
            <div
              className='mt-5 has-text-centered'
              style={{ fontSize: '14px', lineHeight: 1.35, color: '#47557a' }}
            >
              Questions? Contact the referring source,
              <br />
              and review our <a href='https://fundsvalidator.com/faq/' target='_blank' rel='noopener noreferrer'>FAQ</a>,
              <br />
              <a href={legalUrl('/privacy/')} target='_blank' rel='noopener noreferrer'>Privacy Policy</a>, <a href={legalUrl('/cookies/')} target='_blank' rel='noopener noreferrer'>Cookie Policy</a>, and <a href={legalUrl('/terms/')} target='_blank' rel='noopener noreferrer'>Terms of Use</a>.
            </div>
          </div>

          <button onClick={addFundingSource} className="button is-primary color-1 mt-3">Get Started</button>
        </>
      }

      {accounts.length > 0 && 
        <>
        <h2 className="has-text-weight-medium is-size-4 mt-6"><u>Account List</u></h2>
        <table className="table m-auto">
          <thead>
            <tr>
              <th align="center"><abbr title="holder">Account</abbr></th>
              <th align="center"><abbr title="number">Date Added</abbr></th>
            </tr>
          </thead>
          <tbody>
            {accounts.map((account) => 
              <tr key={account.id}>
                <td>{account.name}</td>  
                <td>{account.createdAt}</td>      
              </tr>
            )}
          </tbody>
        </table>
        </>
      }
    </div>
  )
}

FundsVerification.propTypes = {
  identifier: PropTypes.string
};
export default FundsVerification
